import { useNavigate } from "react-router-dom";
import { bnplServices } from "../helpers/bnpl-services";

const Services = () => {
  const navigate = useNavigate();

  return (
    <div className="p-10 px-5 md:px-10 flex flex-col gap-10">
      <div className="flex flex-col gap-2">
        <h1 className="text-4xl font-medium">BNPL Services</h1>
        <div className="text-gray-500">
          Empowering you to buy now and pay later with flexible, secure, and
          convenient payment solutions.
        </div>
      </div>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-2 md:gap-4">
        {bnplServices
          .sort((a, b) => (a.status === "unavailable" ? 1 : -1))
          .map((service, key) => (
            <button
              onClick={() => {
                navigate(
                  service.key === "aviation"
                    ? "/aviation/start"
                    : `/${service.key}`,
                  {
                    state: {
                      name: service.key,
                    },
                  }
                );
              }}
              disabled={service.status === "unavailable"}
              style={{
                opacity: service.status === "unavailable" ? 0.4 : 1,
              }}
              className="flex-col gap-2 inline-flex mr-2.5"
              key={key}
            >
              <img
                src={service.display_img}
                alt="logo"
                draggable={false}
                className="rounded-2xl w-full aspect-video bg-gray-50 border object-cover"
              />
              <div className="text-left flex flex-col gap-1">
                <div className="w-full font-medium text-lg">
                  {service.bnpl_service_name}{" "}
                  {service.status === "unavailable" && "(soon)"}
                </div>
                <div className="">{service.description}</div>
              </div>
            </button>
          ))}
      </div>
    </div>
  );
};

export default Services;
